module.exports = "/assets/dist/img/grad-stat-border-bg.png?65f41107e946bfe5073b7e185342e7fe";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/grad-images/home/index/assets/grad-stat-border-bg.png
// module id = 1700
// module chunks = 10